import { Grid } from '@material-ui/core';
import { Link as LinkTag } from '@heronhr/trivia-games';
import React, { useState } from 'react';
import localStorage from 'utils/localStorage';
import timezones from 'data/timezones';
import Picker from 'components/Picker';
import AutoComplete from 'components/Autocomplete';
import PropTypes from 'prop-types';
import styles from '../styles.module.scss';

const webkitFill = '-webkit-fill-available';

const Schedule = (props) => {
  const {
    goBack,
    schedule,
    date,
    time,
    handleChange,
    selectedTeam,
    selectedChannel,
    selectedTimezone,
    channels: channelsProps,
    hasNewSchedules
  } = props;

  const showTeams = localStorage.getPlatform() === 'teams';
  const getPlatformSpecificContext = (_team, slack) => {
    if (showTeams) {
      return _team || '';
    }
    return slack;
  };
  const [team, setTeam] = useState(showTeams ? selectedTeam : null);
  let teams = [];
  let channels = [];
  if (showTeams) {
    teams = channelsProps;
  } else {
    channels = channelsProps;
  }
  if (team) {
    channels = channelsProps.find((t) => t?.id === team?.id)?.channels || [];
  }
  if (team && channelsProps?.length === 1) {
    channels = channelsProps[0].channels;
  }
  return (
    <div className={styles.scheduleContainer}>
      {!hasNewSchedules && <LinkTag onClick={goBack}>{'< Go back to schedule details'}</LinkTag>}
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <div className={styles.label}>Date</div>
          <div className={styles.pickerWrapper}>
            <Picker
              type='date'
              value={schedule?.time || date}
              handleChange={(value) => handleChange('date', value)}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className={styles.label}>Time</div>
          <div className={styles.pickerWrapper}>
            <Picker
              type='time'
              value={schedule?.time || time}
              handleChange={(value) => handleChange('time', value)}
              minutesStep={1}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className={styles.label}>{getPlatformSpecificContext('Team', 'Channel')}</div>
          <AutoComplete
            options={getPlatformSpecificContext(teams, channels)}
            placeholder={`Select ${getPlatformSpecificContext('Team', 'Channel')}`}
            onSelect={(value) => {
              if (showTeams) setTeam(value);
              handleChange(getPlatformSpecificContext('selectedTeam', 'selectedChannel'), value);
            }}
            filterOptions={(options, inputValue) =>
              options.filter((op) => op.name?.toLowerCase().includes(inputValue.toLowerCase()))
            }
            renderOption={(option) => (
              <div>{getPlatformSpecificContext(option.name, `${option.name}`)}</div>
            )}
            value={getPlatformSpecificContext(selectedTeam, selectedChannel)}
            resetSearchOnSelect={false}
            style={{ width: webkitFill, borderRadius: '8px' }}
            getOptionLabel={(option) => option.name}
            useAsSelect
            initialValue={getPlatformSpecificContext(selectedTeam?.name, selectedChannel?.name)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <div className={styles.label}>Timezone</div>
          <AutoComplete
            options={timezones}
            placeholder='Select Timezone'
            onSelect={(value) => handleChange('selectedTimezone', value)}
            filterOptions={(options, inputValue) =>
              options.filter((op) => op.name.toLowerCase().includes(inputValue.toLowerCase()))
            }
            renderOption={(option) => <div>{option.name}</div>}
            value={selectedTimezone}
            resetSearchOnSelect={false}
            style={{ width: webkitFill, borderRadius: '8px' }}
            getOptionLabel={(option) => option.name}
            useAsSelect
            initialValue={selectedTimezone?.name}
          />
        </Grid>
        {showTeams && (
          <Grid item xs={12} md={6}>
            <div className={styles.label}>Channel</div>
            <AutoComplete
              options={channels}
              placeholder='Select Channel'
              onSelect={(value) => handleChange('selectedChannel', value)}
              filterOptions={(options, inputValue) =>
                options.filter((op) => op.name?.toLowerCase().includes(inputValue.toLowerCase()))
              }
              renderOption={(option) => <div>{option.name}</div>}
              value={selectedChannel}
              resetSearchOnSelect={false}
              style={{ width: webkitFill, borderRadius: '8px' }}
              getOptionLabel={(option) => option.name}
              useAsSelect
              initialValue={selectedChannel?.name}
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

Schedule.propTypes = {
  goBack: PropTypes.func.isRequired,
  schedule: PropTypes.shape({
    time: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
  }),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
  // time is getting instance of moment() date object
  time: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
  handleChange: PropTypes.func.isRequired,
  selectedTeam: PropTypes.shape(),
  selectedChannel: PropTypes.shape(),
  selectedTimezone: PropTypes.shape(),
  channels: PropTypes.arrayOf(PropTypes.shape([])).isRequired,
  hasNewSchedules: PropTypes.bool.isRequired
};

Schedule.defaultProps = {
  selectedTimezone: '',
  schedule: null,
  selectedChannel: null,
  selectedTeam: null
};

export default Schedule;
